import { createSelector } from 'reselect';

import { State } from '@wetransfer/transfer/store/types';

export const selectRoute = (state: State): State['route'] => state.route;

export const selectTransferIdParam = createSelector(
  selectRoute,
  (route) => route.params?.id || undefined
);

export const selectTransferSecretParam = createSelector(
  selectRoute,
  (route) => route.params?.secret || undefined
);

export const selectFileIdParam = createSelector(
  selectRoute,
  (route): string | undefined => route?.params.file_id
);

export const selectRecipientIdParam = createSelector(
  selectRoute,
  (route): string | undefined => route?.params.recipient_id
);

export const selectRoutePath = createSelector(
  selectRoute,
  (route): string => route.path
);

export const selectRouteQuery = createSelector(
  selectRoute,
  (route) => route.query
);

export const selectRouteQueryDuration = createSelector(
  selectRouteQuery,
  (routeQueryDuration) => {
    const { duration } = routeQueryDuration;

    return duration;
  }
);

export const selectRouteQueryRenewal = createSelector(
  selectRouteQuery,
  (routeQueryRenewal) => {
    const { renewal } = routeQueryRenewal;

    return renewal;
  }
);

export const selectRouteQueryFree = createSelector(
  selectRouteQuery,
  (routeQueryFree) => {
    const { free } = routeQueryFree;

    return free;
  }
);
